import { useState } from 'react';

import { CLICK_ACTIONS } from '../constants';

const useOpenOldWidget = () => {
    const [showLoader, setShowLoader] = useState(false);

    const openOldPlugin = () => {
        if (typeof window.OpenPluginFromReact === 'function') {
            window.OpenPluginFromReact();
            setShowLoader(false);
        } else {
            setTimeout(() => {
                openOldPlugin();
            }, 100);
        }
    };

    const openEmailForm = () => {
        if (typeof window.openEmailFormReact === 'function') {
            window.openEmailFormReact();
            setShowLoader(false);
        } else {
            setTimeout(() => {
                openEmailForm();
            }, 100);
        }
    };

    // TODO: MAKE THIS BETTER
    const openClick2Call = () => {
        if (typeof window.openClick2CallReact === 'function') {
            window.openClick2CallReact();
            setShowLoader(false);
        } else {
            setTimeout(() => {
                openClick2Call();
            }, 100);
        }
    };

    const openChat = () => {
        if (typeof window.openChatReact === 'function') {
            window.openChatReact();
            setShowLoader(false);
        } else {
            setTimeout(() => {
                openChat();
            }, 100);
        }
    };

    const clickHandler = (clickAction) => {
        if (clickAction === CLICK_ACTIONS.OPEN_PLUGIN) {
            setShowLoader(true);
            openOldPlugin();
        } else if (clickAction === CLICK_ACTIONS.OPEN_EMAIL_FORM) {
            setShowLoader(true);
            openEmailForm();
        } else if (clickAction === CLICK_ACTIONS.OPEN_CLICK_2_CALL) {
            setShowLoader(true);
            openClick2Call();
        } else if (clickAction === CLICK_ACTIONS.OPEN_CHAT) {
            setShowLoader(true);
            openChat();
        }
    };

    return { showLoader, clickHandler };
};

export default useOpenOldWidget;
